<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Review and rating Management </h1>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="tab-pane1">
                            <div>
                                <form [formGroup]="searchForm">
                                    <div class="row w-100">
                                        <div class="col-md-6">
                                            <div class="filter_search mb20 width100">
                                                <div class="input-group filter_search_group">
                                                    <input type="text" class="form-control overflow-text"
                                                        formControlName="search" placeholder="Search" maxlength="60">
                                                    <div class="input-group-append">
                                                        <button class="btn btn_search_group" type="button">
                                                            <img src="assets/img/icon-search.png" alt="Search" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr class="no_wrap_th text-center">
                                        <th class="Sorting-img"> S.No.</th>
                                        <th class="Sorting-img">Reviewed By</th>
                                        <th class="Sorting-img">Reviewed To</th>
                                        <th class="Sorting-img">Feedback</th>
                                        <th class="Sorting-img">Date</th>
                                        <!-- <th class="Sorting-img">Rating by</th> -->
                                        <th style="width: 200px" class="action_td_btn3 Sorting-img">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (
                                    item of feedBackList
                                    | paginate: {
                                    itemsPerPage: itemPerPage,
                                    currentPage: currentPage,
                                    totalItems: total
                                    };
                                    track item?._id;
                                    let i = $index
                                    ) {
                                    <tr class="text-center">
                                        <td>{{ itemPerPage * (currentPage - 1) + i + 1 }}</td>

                                        <td class="content">
                                            {{ item?.givenBy?.firstName || '--' }} {{ item?.givenBy?.lastName || '' }}
                                        </td>

                                        <td class="content">
                                            {{ item?.givenTo?.firstName || '--' }} {{ item?.givenTo?.lastName || '' }}
                                        </td>

                                        <td class="content">{{ item?.feedback || '--' }}</td>

                                        <td class="content">{{ item?.createdAt | date: 'd/M/y' : 'UTC' }}</td>

                                        <td class="text-center action_td">
                                            <button class="btn btn-info ms-2 bt-margin" title="view"
                                                (click)="viewReview(item?._id)">
                                                <i class="fa fa-eye" style="color:white"></i>
                                            </button>

                                            <button class="btn btn-danger ms-2 bt-margin" title="delete"
                                                (click)="deleteFaqModal(item?._id)">
                                                <i class="fa fa-trash" style="color:white"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    }

                                    @if(!feedBackList.length){
                                    <tr>
                                        <td class="table-no-record" colspan="7">No Record Found</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            @if(total > 10){
                            <div class="custom-pagination d-flex justify-content-end py-4">
                                <pagination-controls (pageChange)="getFeedbackList($event)"></pagination-controls>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- delete_modal Start -->
<div class="modal fade global-modal reset-modal" id="delete">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete Review and rating?</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to delete this review and rating?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" (click)="deleteReview()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- delete_modal End -->